import type { DocumentStateExportFilters } from "~/types/ReportingDocumentStateExport";

export const buildDocumentStateExportBody = (
  filters: DocumentStateExportFilters,
) => {
  return {
    documentTypeIds: filters.mediaTypeIds,
    createdByUserId: filters.createdByUserId,
    merchantId: filters.merchantId,
    marketIds: filters.marketIds,
  };
};
